<template>
	<ui-dialog
		ref="dialog"
		closable
		title="Edit stream"
	>
		<ui-input
			v-model="streamTitle"
			label="Stream title"
		/>
		<ui-input
			v-if="streamURI !== null"
			v-model="streamURI"
			label="RTMP URL"
			hint="Concatenate server URL and stream key separated by a slash (/), to form a complete URL"
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching || streamTitle.length === 0"
				primary
				text="Update"
				tooltip="Update stream with new title"
				@click="updateStream"
			/>
		</ui-dialog-footer>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiDialog from "lib/components/ui/Dialog";
import UiDialogFooter from "lib/components/ui/DialogFooter";
import UiInput from "lib/components/ui/Input";

export default {
	name: "StreamEditDialog",
	components: {
		UiButton,
		UiDialog,
		UiDialogFooter,
		UiInput
	},
	data() {
		return {
			isFetching: false,
			streamTitle: "",
			streamURI: null
		};
	},
	mounted() {
		this.open = (stream) => {
			this.streamId = stream.stream_id;
			this.streamTitle = stream.title;
			this.streamURI = stream.uri;

			this.$refs.dialog.open();
		};
	},
	methods: {
		updateStream() {
			const parameters = {
				title: this.streamTitle
			};

			if (this.streamURI !== null)
				parameters.uri = this.streamURI;

			this.isFetching = true;

			http.patch(`/api/v2/recorder/stream/${this.streamId}`, parameters)
			.then(() => {
				this.$refs.dialog.close();
				this.$emit("update", this.streamId);
			})
			.catch((error) => {
				alert.error("Unable to update stream", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		}
	}
};
</script>
